import styled from 'styled-components';
import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './games-grid.default.box';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

const PcBox = styled(BasePcBox)`
    margin-top: 1.4rem;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        margin-top: 1.8rem;
    }
`;


const MobileBox = BaseMobileBox;

export const GamesGridCasino777Box = styledByDevice(PcBox, MobileBox);